import type { ToolPublic } from "@common/client"
import { daysUntil } from "./labels"

export const VIEWS = [
  "available",
  "out",
  "calibration_due",
  "out_of_service",
  "precision",
] as const

export type View = (typeof VIEWS)[number]

export const TABS = ["all", ...VIEWS] as const

export type Tab = (typeof TABS)[number]

export function tabLabel(tab: Tab): string {
  switch (tab) {
    case "all":
      return "All"
    case "available":
      return "Available"
    case "out":
      return "Tools out"
    case "calibration_due":
      return "Cal due"
    case "out_of_service":
      return "Out of service"
    case "precision":
      return "Precision"
  }
}

export function inTab(tool: ToolPublic, tab: Tab): boolean {
  switch (tab) {
    case "all":
      return true
    case "available":
      return tool.issuability === "issuable"
    case "out":
      return tool.status === "on_loan"
    case "calibration_due":
      return (
        tool.status !== "retired" &&
        (tool.calibration_status === "due_soon" ||
          tool.calibration_status === "overdue")
      )
    case "out_of_service":
      return (
        tool.status === "out_of_service" || tool.status === "in_calibration"
      )
    case "precision":
      return tool.is_precision
  }
}

export function isLoanOverdue(tool: ToolPublic): boolean {
  return tool.loan_due_on !== null && daysUntil(tool.loan_due_on) < 0
}

export function needsAttention(tools: ToolPublic[], tab: Tab): boolean {
  switch (tab) {
    case "out":
      return tools.some(isLoanOverdue)
    case "calibration_due":
      return tools.some(
        (tool) =>
          tool.status !== "retired" && tool.calibration_status === "overdue",
      )
    default:
      return false
  }
}
